import request from '@/utils/request'
import { AppFieldDTO, AppStepSectionDTO, SelectItem, SelectItemList } from './types-app'

const ADMIN_ROUTE = 'api/v1/admin/'

export const getAppStepsTree = async() =>
  request({
    url: ADMIN_ROUTE + 'app/steps',
    method: 'get'
  })

export const getAllAppFields = async() =>
  request({
    url: ADMIN_ROUTE + 'app/fields',
    method: 'get'
  })

export const addAppField = async(appFieldDTO: AppFieldDTO) =>
  request({
    url: ADMIN_ROUTE + 'app/fields/add-or-update',
    method: 'post',
    data: appFieldDTO
  })

export const addOrRemoveRelatedFields = async(appFieldDTO: AppFieldDTO) =>
  request({
    url: ADMIN_ROUTE + 'app/fields/related/add-or-remove',
    method: 'post',
    data: appFieldDTO
  })

export const addOrRemoveChildrenGroup = async(appFieldDTO: AppFieldDTO) =>
  request({
    url: ADMIN_ROUTE + 'app/fields/children-group/add-or-remove',
    method: 'post',
    data: appFieldDTO
  })

export const getAllSelectItemList = async() =>
  request({
    url: ADMIN_ROUTE + 'select-item-list/all',
    method: 'get'
  })

export const getValueTypeList = async() =>
  request({
    url: ADMIN_ROUTE + 'value-type/all',
    method: 'get'
  })

export const getFieldTypeList = async() =>
  request({
    url: ADMIN_ROUTE + 'field-type/all',
    method: 'get'
  })

export const saveAppStep = async(data: Array<AppStepSectionDTO>) =>
  request({
    url: ADMIN_ROUTE + 'app/steps',
    method: 'post',
    data
  })

export const saveAppStepFields = async(data: AppStepSectionDTO) =>
  request({
    url: ADMIN_ROUTE + 'app/steps/fields',
    method: 'post',
    data
  })
export const addSelectItem = async(data: SelectItem) =>
  request({
    url: ADMIN_ROUTE + 'select-item-list/item/new',
    method: 'post',
    data
  })

export const updateSelectItem = async(data: SelectItem) =>
  request({
    url: ADMIN_ROUTE + 'select-item-list/item/update',
    method: 'post',
    data
  })

export const createSelectItemList = async(data: SelectItemList) =>
  request({
    url: ADMIN_ROUTE + 'select-item-list/new',
    method: 'post',
    data
  })

export const getOrderTypeList = async() =>
  request({
    url: ADMIN_ROUTE + 'order-type/all',
    method: 'get'
  })
